import { Header, ImageBanner } from "src/components";
import { Box, Typography } from "@mui/material";
import { IDENTITY_IMAGES } from "src/shared/assets/images";
import { useTranslation } from "react-i18next";
import { SearchPageContainer } from "../Search/SearchPageContainer";
import { onDesktop } from "src/shared/theme/breakpoint";
import { IdvFailureReason } from "src/utils/idvFailureReason";

export interface IIdentityStatusScreen {
  onBackButtonClick?: VoidFunction;
  onSubmitEvent?: VoidFunction;
  submitButtonText?: string;
  failureReason?: IdvFailureReason | null;
  // Optional multi-reason list. When provided with 2+ entries the screen
  // renders all of them; otherwise we fall back to the single `failureReason`.
  failureReasons?: IdvFailureReason[] | null;
}
export const IdentityFailed = ({
  onSubmitEvent,
  onBackButtonClick,
  submitButtonText,
  failureReason,
  failureReasons,
}: IIdentityStatusScreen) => {
  const { t } = useTranslation();

  const reasonsList =
    failureReasons && failureReasons.length > 1 ? failureReasons : null;
  const primary =
    failureReason || (failureReasons && failureReasons[0]) || null;
  const nonRetriable =
    (failureReasons && failureReasons.some((r) => r.retriable === false)) ||
    primary?.retriable === false;

  const reasonContent = primary
    ? t(`account.plaidIdentityVerification.failure.${primary.code}`, {
        defaultValue: t("headingContent.statusses.identityFailed.content"),
      })
    : t("headingContent.statusses.identityFailed.content");

  return (
    <SearchPageContainer
      submitButtonText={submitButtonText || t("buttonTexts.continueButton")}
      onSubmitEvent={onSubmitEvent}
    >
      <Header
        isBackButtonVisible={Boolean(onBackButtonClick)}
        onBackButtonClick={onBackButtonClick}
        paddingX={0}
      />
      <ImageBanner
        imgAlt="Identity Failed"
        imgPath={IDENTITY_IMAGES.FAILED}
        imgWidth="352px"
      />
      <Box textAlign="center" sx={{ mb: 4, [onDesktop]: { mb: 12 } }}>
        <Typography variant="h6ExtraBold" component="div" mb={3}>
          {t("headingContent.statusses.identityFailed.heading")}
        </Typography>
        {reasonsList ? (
          <Box
            component="ul"
            sx={{ textAlign: "left", pl: 3, m: 0, display: "inline-block" }}
          >
            {reasonsList.map((r) => (
              <Typography
                component="li"
                variant="body2"
                key={r.code}
                sx={{ mb: 1 }}
              >
                {t(`account.plaidIdentityVerification.failure.${r.code}`, {
                  defaultValue: t(
                    "headingContent.statusses.identityFailed.content"
                  ),
                })}
              </Typography>
            ))}
          </Box>
        ) : (
          <Typography variant="body2">{reasonContent}</Typography>
        )}
        {nonRetriable && (
          <Typography variant="body2" sx={{ mt: 2 }}>
            {t("account.plaidIdentityVerification.contactSupport")}{" "}
            <a href="mailto:support@tenantport.com">support@tenantport.com</a>
          </Typography>
        )}
      </Box>
    </SearchPageContainer>
  );
};
